import { ICustomerType } from "@/core/model/sys/ICustomer";
import IParamServices from "../IParamServices";
import BaseService from "./BaseService";
import { IServiceResponse } from "@/core/model/rest/IServiceResponse";

export default class GenericService extends BaseService
{
  constructor(param: IParamServices)
  {
    super(param);
  } 
  public NewCustomerType() : ICustomerType
  {
    return{
      CustomerTypeId:0,
      CustomerTypeName: '',
      ModifiedBy:0,
      ModifiedByEmployee:null,
      ModifiedTime: new Date(),
      AllowParent:false,
      Active: true
    };
  }
  public async ListCustomerType():Promise<ICustomerType[]>
  {
    const list = Array<ICustomerType>();
    const response:IServiceResponse = await this.Get('IndexGeneric/ListCustomerType',null,null,null,true,false,null);  
    if(response.Response)
    {      
      for (const element of response.Response)
      {        
        list.push({...element});  
      }
    }    
    return list;
  }
  public async SaveCustomerType(customerType:ICustomerType):Promise<ICustomerType|null>
  {
    const response:IServiceResponse =  await this.Post('IndexGeneric/SaveCustomerType',customerType,null,null,null,true,false,null);           
    if(response && response.Response)
    {      
      return response.Response;
    }
    else
      return null;
  }

}
